import { render, staticRenderFns } from "./BaseBanner.vue?vue&type=template&id=3904302e&scoped=true&"
import script from "./BaseBanner.vue?vue&type=script&lang=ts&"
export * from "./BaseBanner.vue?vue&type=script&lang=ts&"
import style0 from "./BaseBanner.vue?vue&type=style&index=0&id=3904302e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3904302e",
  null
  
)

export default component.exports